var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeMoreMobileSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 7.5C0.333252 11.18 3.31992 14.1667 6.99992 14.1667C10.6799 14.1667 13.6666 11.18 13.6666 7.5C13.6666 3.82 10.6799 0.833338 6.99992 0.833338C3.31992 0.833338 0.333252 3.82 0.333252 7.5ZM12.3333 7.5C12.3333 10.44 9.93992 12.8333 6.99992 12.8333C4.05992 12.8333 1.66659 10.44 1.66659 7.5C1.66659 4.56001 4.05992 2.16667 6.99992 2.16667C9.93992 2.16667 12.3333 4.56001 12.3333 7.5ZM8.99992 7.5L6.33325 4.83334L6.33325 10.1667L8.99992 7.5Z",
    fill: "rgba(255, 255, 255, 0.4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMoreMobileSvg);
export default __webpack_public_path__ + "static/media/seeMoreMobileSvg.ab50086c.svg";
export { ForwardRef as ReactComponent };